import useGetProductIndexWithMask from "../../../Components/BasketPage/Hooks/useGetProductIndexWithMask"
import { CapitalizeFirstLowercaseRest, ConvertPriceToString } from "../../../Helpers/CustomConverter"
import { useParams } from "../../../Providers/ParamsProvider"
import { OverlayTrigger, Popover } from "react-bootstrap";

const OferDetailsProducts = ({ items, isOfferRequest }) => {
    const { isMobile } = useParams()

    return (<>
        <b className="panel-header-title">Lista produktów: </b>
        <div className="table-responsive mt-4">
            <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                <thead>
                    <tr>
                        <th style={{ alignContent: 'center', textAlign: 'left', fontWeight: 'normal', width: "9%", verticalAlign: 'middle' }}>
                            Indeks
                        </th>
                        <th style={{ alignContent: 'center', textAlign: 'left', fontWeight: 'normal', width: "auto" }}>
                            Nazwa
                            <br />
                            Cecha
                        </th>
                        <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "5%", verticalAlign: 'middle' }}>
                            Rabat
                        </th>
                        <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "10%", verticalAlign: 'middle' }}>
                            Cena netto PLN
                        </th>
                        <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "6%", verticalAlign: 'middle' }}>
                            Ilość
                        </th>
                        {!isOfferRequest && <>
                            <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "6%", verticalAlign: 'middle' }}>
                                Il. zam.
                            </th>
                            <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "6%", verticalAlign: 'middle' }}>
                                Il. zreal.
                            </th>
                        </>}
                        <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "5%", verticalAlign: 'middle' }}>
                            Jedn.
                        </th>
                        <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "11%", verticalAlign: 'middle' }}>
                            Wartość netto PLN
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items && items.length > 0 && items.map((item, key) => {
                        return <OfferItem
                            key={key}
                            item={item}
                            isOfferRequest={isOfferRequest}
                        />
                    })}
                </tbody>
            </table>
        </div>
    </>)
}

const OfferItem = ({ item, isOfferRequest }) => {
    const { getProductIndexWithMask } = useGetProductIndexWithMask()

    const popover = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>* Ceny w PLN są przeliczane z cen bazowych (walutowych) wg
                kursu sprzedaży NBP z dnia poprzedzającego wydruk oferty.
                Ceny na dokumentach sprzedażowych zostaną zaktualizowane
                wg kursu sprzedaży walut NBP w dniu poprzedzającym
                wystawienie dokumentu sprzedaży</span>
        </Popover.Body>
    </Popover>

    return (
        <tr className='hoverable-row'>
            <td style={{ alignContent: 'center', textAlign: 'left', verticalAlign: 'middle' }}>
                {getProductIndexWithMask(item.artNo)}
            </td>
            <td style={{ alignContent: 'center', textAlign: 'left', verticalAlign: 'middle' }}>
                {CapitalizeFirstLowercaseRest(item.artName)}
                <br />
                {CapitalizeFirstLowercaseRest(item.artLabel)}
            </td>
            <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                {`${isNaN(item.discount) ? 0 : parseFloat(item.discount).toFixed(1)} %`}
            </td>
            <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                <div>
                    <span>{ConvertPriceToString(item.priceNet, null)}</span>
                    {item.foreignCurrency && <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                        <span className='primary-accent-color-text'>*</span>
                    </OverlayTrigger>}
                </div>
            </td>
            <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                {item.qty}
            </td>
            {!isOfferRequest && <>
                <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                    {item.orderQty}
                </td>

                <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                    {item.realizedQty}
                </td></>}
            <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                {item.baseUnit}
            </td>
            <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                <div>
                    <span>{ConvertPriceToString((item.priceNet * item.qty), null)}</span>
                    {item.foreignCurrency && <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                        <span className='primary-accent-color-text'>*</span>
                    </OverlayTrigger>}
                </div>
            </td>
        </tr>
    )
}

export default OferDetailsProducts